import { formatDanishDateTimeSeconds } from './danishDateTime';

const CIVIL = /^(\d{4})-(\d{2})-(\d{2})$/;
const DANISH = /^(\d{1,2})[.\-/](\d{1,2})[.\-/](\d{4})$/;

export function formatDanishCivilDate(civil: string | null | undefined): string {
  if (!civil) return '';
  const match = CIVIL.exec(civil.trim());
  if (!match) return '';
  return `${match[3]}-${match[2]}-${match[1]}`;
}

export function parseDanishCivilDate(text: string | null | undefined): string | null {
  if (!text) return null;
  const trimmed = text.trim();
  const iso = CIVIL.exec(trimmed);
  if (iso) return civilIfValid(Number(iso[1]), Number(iso[2]), Number(iso[3]));
  const danish = DANISH.exec(trimmed);
  if (!danish) return null;
  return civilIfValid(Number(danish[3]), Number(danish[2]), Number(danish[1]));
}

function civilIfValid(year: number, month: number, day: number): string | null {
  if (!Number.isFinite(year) || !Number.isFinite(month) || !Number.isFinite(day)) return null;
  if (year < 1900 || year > 2100 || month < 1 || month > 12 || day < 1 || day > 31) return null;
  const date = new Date(year, month - 1, day);
  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return null;
  }
  return `${String(year).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}

export function formatDanishDateTime(
  iso: string | null | undefined,
  timeLabel: (date: Date) => string,
): { date: string; time: string } | null {
  if (!iso) return null;
  const parsed = Date.parse(iso);
  if (Number.isNaN(parsed)) return null;
  const date = new Date(parsed);
  const civil = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  return { date: formatDanishCivilDate(civil), time: timeLabel(date) };
}

/** "22-10-2026 17:08:28" in Europe/Copenhagen. Ignores the browser locale. */
export function formatDanishTimestamp(iso: string | null | undefined): string {
  return formatDanishDateTimeSeconds(iso);
}
